import { withRouter } from 'react-router-dom';
import { GApageView, GAevent } from '../../analytics';
import { Category, Action } from '../../analytics/constants';

const RouteChangeTracker = ({ history }) => {
    history.listen((location) => {
        GApageView(location.pathname);
        GAevent(Action.visit_page, Category.navigation, location.pathname);
    });

    return null;
};

export default withRouter(RouteChangeTracker);
